import React from 'react';
import * as timeago from 'timeago.js';
import { Box, Typography } from '@mui/material';
import { getDataValue, getEntryTimestamp, getTimestampMillis, latestEntry } from '../utils';

const Settings = {
  Name: 'LastSeen',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'label', type: 'text', name: 'Label', default: 'Last seen' },
      { id: 'datePath', type: 'text', name: 'Date path', placeholder: 'Leave blank to use latest entry date' },
      { id: 'showExact', type: 'switch', name: 'Show exact date' },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'Unknown' },
    ],
    grid: true,
  },
};

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const entry = latestEntry(DeviceData);
  const configuredDate = userSettings.datePath ? getDataValue(entry, userSettings.datePath) : undefined;
  const timestamp = getTimestampMillis(configuredDate) || getEntryTimestamp(entry);
  const label = userSettings.label || 'Last seen';

  if (!timestamp) {
    return (
      <Box>
        <Typography component="strong" sx={{ fontWeight: 700 }}>{label}: </Typography>
        <Typography component="span">{userSettings.emptyText || 'Unknown'}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography component="strong" sx={{ fontWeight: 700 }}>{label}: </Typography>
      <Typography component="span">{timeago.format(timestamp)}</Typography>
      {userSettings.showExact ? (
        <Typography component="span" color="text.secondary"> ({new Date(timestamp).toLocaleString('en-AU')})</Typography>
      ) : null}
    </Box>
  );
};

export default {
  Settings,
  View,
};
